import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { InventoryOrderSearchRowLinesRequest, InventoryOrderSearchRowLinesResponse, UpdateInventoryOrderNumberRequest, OrderInventoryOrdersRequest, InventoryOrderEmailToVendorRequest, InventoryOrderOptionRequest, UpdateInventoryOrderLineQuantityRequest, AddInventoryOrderLineRequest, DeleteInventoryOrderLineRequest, InventoryOrderLineViewModel, InventoryOrderLinesRequest, OrderInventoryOrderRequest, CancelInventoryOrderRequest, VoidInventoryOrderRequest } from '../models/inventory-orders';

@Injectable({
  providedIn: 'root'
})
export class InventoryOrderDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getInventoryOrderSearchRowLinesAsync(request: InventoryOrderSearchRowLinesRequest, cancellationToken: Promise<any>): Promise<InventoryOrderSearchRowLinesResponse> {
    return this.httpClient.getJsonAsync<InventoryOrderSearchRowLinesResponse>('InventoryOrders/GetInventoryOrderSearchRowLines', request, cancellationToken);
  }

  orderInventoryOrdersAsync(request: OrderInventoryOrdersRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/OrderInventoryOrders', request, cancellationToken);
  }

  updateInventoryOrderNumberAsync(request: UpdateInventoryOrderNumberRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/UpdateInventoryOrderNumber', request, cancellationToken);
  }

  sendEmailToVendorAsync(request: InventoryOrderEmailToVendorRequest, cancellationToken: Promise<any>): Promise<boolean> {
    return this.httpClient.getJsonAsync('InventoryOrders/SendEmailToVendor', request, cancellationToken);
  }

  getInventoryOrderOptionsAsync(request: InventoryOrderOptionRequest, cancellation: Promise<any>): Promise<ListOption<number>[]> {

    return this.httpClient.getJsonAsync<ListOption<number>[]>('InventoryOrders/Options', request, cancellation, false);
  }

  orderInventoryOrderAsync(request: OrderInventoryOrderRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/OrderInventoryOrder', request, cancellationToken);
  }

  getInventoryOrderLinesAsync(request: InventoryOrderLinesRequest, cancellationToken: Promise<any>): Promise<InventoryOrderLineViewModel[]> {
    return this.httpClient.getJsonAsync('InventoryOrders/InventoryOrderLines', request, cancellationToken);
  }

  addInventoryOrderLineAsync(request: AddInventoryOrderLineRequest, cancellationToken: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync('InventoryOrders/AddInventoryOrderLine', request, cancellationToken);
  }

  updateInventoryOrderLineQuantityAsync(request: UpdateInventoryOrderLineQuantityRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/UpdateInventoryOrderLineQuantity', request, cancellationToken);
  }

  deleteInventoryOrderLineAsync(request: DeleteInventoryOrderLineRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/DeleteInventoryOrderLine', request, cancellationToken);
  }

  voidInventoryOrderAsync(request: CancelInventoryOrderRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/VoidInventoryOrder', request, cancellationToken);
  }

  cancelInventoryOrderAsync(request: VoidInventoryOrderRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/CancelInventoryOrder', request, cancellationToken);
  }

  getOrderIntegrationInventoryLinesExistsAsync(clinicId: number, productStyleId: number, timeout: Promise<any>): Promise<boolean> {
    const request = { clinicId: clinicId, productStyleId: productStyleId };
    return this.httpClient.getJsonAsync<boolean>('InventoryOrders/OrderIntegrationInventoryLinesExists', request, timeout, false);
  }

  getOrderIntegrationOrderLineFromSerialNumber(clinicId: number, productStyleId: number, serialNumber: string, timeout: Promise<any>): Promise<any> {
    const request = { clinicId: clinicId, productStyleId: productStyleId, serialNumber: serialNumber };
    return this.httpClient.getJsonAsync<boolean>('InventoryOrders/GetOrderIntegrationOrderLineFromSerialNumber', request, timeout, false);
  }

  inventoryRequisitionAsync(request: OrderInventoryOrderRequest, cancellationToken: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('InventoryOrders/InventoryRequisition', request, cancellationToken);
  }

  isRequisitionRequest(inventoryOrderId: number, cancellationToken: Promise<any>): Promise<boolean> {
    const request = { inventoryOrderId: inventoryOrderId };
    return this.httpClient.getJsonAsync<boolean>('InventoryOrders/IsRequisitionRequest', request, cancellationToken, false);

  }
  updateSerializedItemOnCancelledOrderLineAppriseAsync(selectedLineIds: number[], timeout: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync('SalesOrderLines/UpdateSerialiedItemOnCancelledOrderLineApprise', selectedLineIds, timeout);
  }
}

